export const GET_ALL_PRODUCTS_DATA = 'getAllProductsData';
export const GET_ALL_PRODUCT_IMAGES_CTA_DIMENSIONS = 'getAllProductImagesCtaDimensions';
export const GET_SLIDEOUT_STACK = 'getSlideoutStack';
export const GET_ACTIVE_MODAL_NAME = 'getActiveModalName';
export const GET_PRODUCT_IMAGES_CTA_SORTED_LIST = 'getProductImagesCtaSortedList';
export const GET_REVIEWS = 'getReviews';
export const GET_REVIEWS_LOADING_STATE = 'getReviewsLoadingState';
export const GET_REVIEWS_PAGE_NUMBER = 'getReviewsPageNumber';
export const GET_REVIEWS_TOTAL_RESULTS = 'getReviewsTotalResults';
export const GET_REVIEWS_OVERALL_PAGES = 'getReviewsOverallPages';
export const GET_REVIEWS_STAR_FILTERING = 'getReviewsStarFiltering';
export const GET_REVIEWS_SORT_BY = 'getReviewsSortBy';
export const GET_REVIEWS_FREQUENTLY_MENTIONED = 'getReviewsFrequentlyMentioned';
export const GET_REVIEWS_SELECTED_FREQUENTLY_MENTIONED = 'getReviewsSelectedFrequentlyMentioned';
export const GET_REVIEWS_STATISTICS = 'getReviewsStatistics';
export const GET_ZIP_CODE_FROM_STORE = 'zipCodeFromStore';
export const GET_ACTIVE_QUANTITY = 'getActiveQuantity';
export const GET_LOAD_STATUS = 'getLoadStatus';
export const GET_GENERATED_SUMMARY = 'getGeneratedSummary';
